import React, { useEffect, useState, useContext } from 'react'
import Story from './Story'
import NoStoriesFound from '@material-ui/icons/PhotoLibrary'
import { makeStyles } from '@material-ui/styles'
import MobileContext from '../context/MobileContext'


const useStyles = makeStyles(({
    storyRoot: {
        display: 'flex', 
        margin: '20px 0', 
        justifyContent: 'center',
         marginBottom: 65
    },
    mobileStoriesRoot: {
        display: 'flex', 
        flexDirection: 'column'
    },
    nonMobileStoriesRoot: {
        display: 'flex', 
        flexDirection: 'column', 
        width: '50%'
    },
    noStoriesFound: {
      width: '5em',
      height: '5em'
    }
  }))

  export default function StoriesList(props){

    const classes = useStyles()
    
    const { stories, showStory } = props

    const Context = useContext(MobileContext)

    const [left, setLeft] = useState([])
    const [right, setRight] = useState([])

    useEffect(() => {

        if(!stories) return

        const left = stories ? stories.filter((_, index) => index % 2 === 0) : []
        const right = stories ? stories.filter((_, index) => index % 2 === 1) : []

        setLeft(left)
        setRight(right)
        
    }, [stories])
    

    if(!stories || stories.length === 0){
        return (
        <div className={classes.storyRoot}>
            <div style={{
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'}}>
                <NoStoriesFound className={classes.noStoriesFound}/>
                <div style={{fontSize: 'larger'}}>No Stories Found</div>
            </div> 
        </div>
        )
    }else if(Context.isMobile){

        return (
            <div className={classes.storyRoot}>
                <div className={classes.mobileStoriesRoot}>
                    {stories.map((story, index) => (
                        <Story key={index} story={story} showStory={showStory}/>
                    ))}
                </div> 
            </div>
        )

    }else{

        return (
            <div className={classes.storyRoot}>
                <div className={classes.nonMobileStoriesRoot}>
                    {left.map((story, index) => (
                        <Story key={index} story={story} showStory={showStory}/>
                    ))}
                </div>
                <div className={classes.nonMobileStoriesRoot}>
                    {right.map((story, index) => (
                        <Story key={index} story={story} showStory={showStory}/>
                    ))}
                </div>  
            </div>
        )

    } 
}